module.exports = __webpack_public_path__ + "img/lukoil-logo-en.03869051.jpg";